import React from 'react';
import {Button} from "@dts-soldel/dts-react-common";
import Pages from "../../app/pages/Pages";

const propTypes = {};
const defaultProps = {};

const UtahHeaderReactComponent = () => {

	return (
		<div key="home">
			<h1 className="bg-primary color-white text-center"><span className="content">Utah Header - React Component</span></h1>
			<div className="content">
				<div className="back-button"><Button label="back" onClick={Pages.public.home.forward}/></div>
				<p>
					Here is an example React Component for working with the utah header. This site uses this component. Please send merge requests for updates to this component!
				</p>
				<p>
					<a
						href="https://git.dts.utah.gov/dts-shared-development/universal-utah-gov-header/-/tree/master/examples/src/js/components/UtahHeader"
						target="_blank"
					>
						React Component for Utah Header (GIT repository)
					</a>
				</p>
				<p>
					See this configuration examples React application for an example of using this component.
				</p>
			</div>
		</div>
	);
};

UtahHeaderReactComponent.propTypes = propTypes;
UtahHeaderReactComponent.defaultProps = defaultProps;

export default UtahHeaderReactComponent;
